import useAnalytics from "@/hooks/useAnalytics";
import useTranslation from "@/hooks/useTranslation";
import { useInviteUser } from "@/hooks/useUser";
import { PlusOutlined } from "@ant-design/icons";
import { Button, Form, Input, message, Modal } from "antd";
import { useState } from "react";

function InviteUser() {
  const [form] = Form.useForm();
  const [open, setOpen] = useState(false);
  const translation = useTranslation();
  const analytics = useAnalytics();

  const inviteUser = useInviteUser();

  const onSubmit = () => {
    const { first_name, last_name, email } = form.getFieldsValue();
    inviteUser
      .mutateAsync({ first_name, last_name, email })
      .then(() => {
        message.success(translation.userInvite.success);
        analytics.track("New user invited");
        setOpen(false);
      })
      .catch((error) => {
        if (error.response.data.message === "User with this email already exists") {
          message.error(translation.errors.email_already_registered);
        } else {
          message.error(translation.errors.general);
        }
      });
  };
  return (
    <>
      <Button
        icon={<PlusOutlined />}
        onClick={() => setOpen(true)}
      >
        {translation.userInvite.buttonText}
      </Button>
      <Modal
        open={open}
        title={translation.userInvite.modaTitle}
        okText={translation.userInvite.okButtonText}
        cancelText={translation.userInvite.cancelButtonText}
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          loading: inviteUser.isLoading,
          disabled: inviteUser.isLoading,
        }}
        cancelButtonProps={{
          disabled: inviteUser.isLoading,
        }}
        onCancel={() => setOpen(false)}
        destroyOnHidden
        modalRender={(dom) => (
          <Form
            layout="vertical"
            form={form}
            name="inviteUserForm"
            onFinish={onSubmit}
          >
            {dom}
          </Form>
        )}
      >
        <Form.Item
          name="first_name"
          label="First name"
          rules={[
            {
              required: true,
              message: translation.userInvite.firstNameValidationError,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="last_name"
          label="Last name"
          rules={[
            {
              required: true,
              message: translation.userInvite.lastNameValidationError,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="email"
          label="Email"
          rules={[
            {
              type: "email",
              message: translation.userInvite.emailInvalidValidationError,
            },
            {
              required: true,
              message: translation.userInvite.emailMissingValidationError,
            },
          ]}
        >
          <Input />
        </Form.Item>
      </Modal>
    </>
  );
}

export default InviteUser;
